angular.module('TetherApp').controller('ClientRoleController', [
    '$window',
    'clientRoleService',
    function (
        $window,
        clientRoleService
    ) {

        let ctrl = this;

        ctrl.delete = function (id) {
            if ($window.confirm(ctrl.deleteConfirmationText)) {
                clientRoleService.deleteClientRole(id)
                    .then(onClientRoleDelete, onError);
            }
        };

        let onClientRoleDelete = function (data) {
            $window.location.href = '/role';
        };

        let onError = function(reason) {
            ctrl.error = 'Could not fetch the data.';
        };

    }
]);
